import React, { useEffect, useState } from "react";
import { Filter } from "lucide-react";
import "./FarmersList.css";
import FarmerFilter from "./Filter";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import { Api_Caller } from "../../../utils/Api";
import moment from "moment";
import ReactPaginate from "react-paginate";
import { getAgentListingApi } from "../../agents/agentService";

const FarmersList = () => {
  const auth = useSelector((state) => state.auth || {});
  const location = useLocation();

  const { PagiNation, Filters } = location.state || {};

  const [pagination, setPagination] = useState(() => ({
    paginationFilter: {
      offset: PagiNation ?? Filters?.paginationFilter?.offset ?? 0,
      limit: Filters?.paginationFilter?.limit ?? 10,
      order: Filters?.paginationFilter?.order ?? "DESC",
    },
    search: Filters?.search ?? "",
    village: Filters?.village ?? "",
    registered: Filters?.registered ?? "",
    agentId: Filters?.agentId ?? "",
  }));

  const [farmerList, setFarmerList] = useState([]);
  const [totalElements, setTotalElements] = useState(0);
  const [loading, setLoading] = useState(false);
  const [agents, setAgents] = useState([]);

  const { offset, limit } = pagination.paginationFilter;

  const getAgentListing = async () => {
    try {
      const response = await getAgentListingApi(auth.accessToken);
      setAgents(response.data.data || []);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    let isMounted = true;
    const getFarmerList = async () => {
      try {
        setLoading(true);

        const params = {
          page: offset,
          size: limit,
          order: pagination.paginationFilter.order,
          search: pagination.search,
          village: pagination.village,
          registered: pagination.registered,
          agentId: pagination.agentId,
        };

        Object.keys(params).forEach((key) => {
          if (params[key] === "" || params[key] == null) {
            delete params[key];
          }
        });

        const response = await axios.get(
          `${process.env.REACT_APP_API_ALL}/${Api_Caller.getFarmer}`,
          {
            params,
            headers: {
              Authorization: `Bearer ${auth.accessToken}`,
            },
          },
        );

        if (isMounted) {
          setFarmerList(response?.data?.content || []);
          setTotalElements(response?.data?.totalElements || 0);
        }
      } catch (error) {
        if (isMounted) {
          console.log("Error fetching farmers:", error);
          setFarmerList([]);
          setTotalElements(0);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    getFarmerList();

    return () => {
      isMounted = false;
    };
  }, [pagination, auth.accessToken]);

  const handlePageClick = ({ selected }) => {
    setPagination((prev) => ({
      ...prev,
      paginationFilter: {
        ...prev.paginationFilter,
        offset: selected,
      },
    }));
  };

  useEffect(() => {
    getAgentListing();
  }, []);

  return (
    <>
      <FarmerFilter
        pagination={pagination}
        setPagination={setPagination}
        agents={agents}
      />

      <div className="card all-cards p-0">
        <div className="card-header bg-white py-6">
          <div className="d-flex justify-content-between">
            <h5 className="mb-0">Farmers</h5>

            <span
              className="collapsed cursor-pointer"
              data-target="#farmerfilter"
              target="filter"
              data-toggle="collapse"
            >
              <Filter target="farmerfilter" noMargin={true} />
            </span>
          </div>
        </div>

        <div className="card-body table-responsive p-4">
          <table
            className="table table-hover align-middle mb-0 table-bordered"
            id="commontable"
          >
            <thead className="theadheading">
              <tr>
                <th className="number-column">Sr. No</th>
                <th>Farmer Name</th>
                <th>Field Agent</th>
                <th>Village / Location</th>
                <th>Registered</th>
                <th>Total Visits</th>
                <th>Last Visit</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td
                    colSpan="7"
                    className="farmers-empty text-center font-weight-bolder"
                  >
                    <div className="farmers-loader">
                      <div className="farmers-spinner"></div>
                      <span>Loading farmers...</span>
                    </div>
                  </td>
                </tr>
              ) : farmerList.length > 0 ? (
                farmerList.map((farmer, index) => {
                  const mobileNumber = farmer?.mobileNumber;

                  return (
                    <tr key={farmer.id || farmer.farmerId || index}>
                      <td>{offset * limit + index + 1}</td>

                      <td>
                        <div className="farmer-name-cell">
                          <div className="farmer-name-info">
                            <strong>{farmer?.farmerName}</strong>
                          </div>
                        </div>
                      </td>

                      <td>{farmer?.agentName || "-"}</td>
                      <td>{farmer?.villageArea || "-"}</td>

                      <td>
                        <span
                          className={`registration-badge ${
                            farmer.registered
                              ? "is-registered"
                              : "not-registered"
                          }`}
                        >
                          {farmer?.registered ? "Yes" : "No"}
                        </span>
                      </td>

                      <td>{farmer?.totalVisits ?? 0}</td>

                      <td>
                        {farmer?.lastVisit
                          ? moment
                              .utc(farmer?.lastVisit)
                              .local()
                              .format("DD-MM-YYYY")
                          : "-"}

                        <br />
                        {farmer?.lastVisit
                          ? moment
                              .utc(farmer?.lastVisit)
                              .local()
                              .format("hh:mm A")
                          : "-"}
                      </td>

                      <td>
                        <Link
                          className="btn btn-sm btn-outline-primary"
                          to="/FarmerProfile"
                          state={{
                            PagiNation: offset,
                            Filters: pagination,
                            mobileNumber: mobileNumber,
                          }}
                        >
                          Details
                        </Link>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td
                    colSpan="7"
                    className="farmers-empty text-center font-weight-bolder"
                  >
                    No farmers found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {!loading && totalElements > 0 && (
            <div className="mt-4">
              {totalElements > limit && (
                <ReactPaginate
                  previousLabel="<<"
                  nextLabel=">>"
                  breakLabel="..."
                  onPageChange={handlePageClick}
                  forcePage={offset}
                  pageCount={Math.ceil(totalElements / limit)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  containerClassName="pagination justify-content-center mb-0"
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  breakClassName="page-item"
                  breakLinkClassName="page-link"
                  activeClassName="active"
                  disabledClassName="disabled"
                  renderOnZeroPageCount={null}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default FarmersList;
